module.exports = __webpack_public_path__ + "static/media/ProximaNovaA-Regular.1f75b12a.woff2";